import { stringify } from 'qs';
import {request} from "../../../utils/apiUtils";
import {URL_API} from "../../../url.config";

let ServiceOtherController = {
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback);
    },
    list: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (productId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other/detail/${productId}`,
            method: 'GET'
        }, callback)
    },
    registerDetail: (productId, callback) => {
        return request({
            url: `${URL_API}/api/sas-school/service-other/register-detail/${productId}`,
            method: 'GET'
        }, callback)
    },
}

export default ServiceOtherController
